import React from "react";

const OrderIcon = props => (
  <svg
    style={props.style}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
  >
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M15.625 4.375h-15v15h15v-15z"
    ></path>
    <path
      stroke={props.color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M.625 4.375l3.75-3.75h15v15l-3.75 3.75M15.625 4.375l3.75-3.75M8.125 4.375l3.75-3.75M5.625 8.125h5"
    ></path>
  </svg>
);

export default OrderIcon;



// WEBPACK FOOTER //
// ./src/icons/OrdersIcon.jsx